(() => {
  function init(root = document) {
    const article = new URL(window.location.href);
    if (article.searchParams.get('view') === 'advertorial') {
      root.querySelectorAll('a[href]').forEach(link => {
        const destination = new URL(link.href, article);
        if (destination.origin !== article.origin || destination.pathname !== article.pathname
          || destination.searchParams.get('view') === 'advertorial') return;
        destination.searchParams.set('return_to', article.pathname + article.search + article.hash);
        link.href = destination.href;
        link.removeAttribute('target');
      });
    }

    root.querySelectorAll('[data-hero-video]:not([data-hero-ready])').forEach(media => {
      const video = media.querySelector('.adv-hero-video');
      const toggle = media.querySelector('[data-hero-video-toggle]');
      if (!video || !toggle) return;
      media.dataset.heroReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let inView = false;
      let userPaused = false;
      let manualPlayback = false;
      let autoplayBlocked = false;
      let playPending = false;
      let failed = false;
      let ended = false;

      const shouldPlay = () => media.isConnected && !failed && !ended && inView && !document.hidden
        && !userPaused && (manualPlayback || (!reducedMotion.matches && !autoplayBlocked));
      const updateToggle = () => {
        toggle.textContent = video.paused ? 'Lire' : 'Pause';
        toggle.setAttribute('aria-label', video.paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
      };
      const updatePlayback = () => {
        if (!shouldPlay()) {
          video.pause();
          return;
        }
        if (!video.paused || playPending) return;
        playPending = true;
        video.play().then(() => {
          if (!shouldPlay()) video.pause();
        }).catch(error => {
          if (error.name !== 'AbortError') {
            autoplayBlocked = true;
            manualPlayback = false;
            media.classList.remove('has-playing-video');
          }
        }).finally(() => {
          playPending = false;
          updateToggle();
        });
      };

      video.muted = true;
      video.addEventListener('playing', () => {
        if (shouldPlay()) media.classList.add('has-playing-video');
        else video.pause();
        updateToggle();
      });
      video.addEventListener('ended', () => { ended = true; updateToggle(); });
      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);
      const handleMediaError = () => {
        failed = true;
        video.pause();
        media.classList.remove('has-playing-video');
        toggle.hidden = true;
      };
      video.addEventListener('error', handleMediaError);
      const sources = [...video.querySelectorAll('source')];
      const failedSources = new Set();
      sources.forEach(source => source.addEventListener('error', () => {
        failedSources.add(source);
        if (failedSources.size === sources.length) handleMediaError();
      }));
      toggle.addEventListener('click', () => {
        if (ended) { ended = false; video.currentTime = 0; }
        userPaused = !video.paused;
        manualPlayback = !userPaused;
        autoplayBlocked = false;
        updatePlayback();
      });
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) manualPlayback = false;
        updatePlayback();
      });
      document.addEventListener('visibilitychange', updatePlayback);
      toggle.hidden = false;
      updateToggle();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          updatePlayback();
        }).observe(media);
      } else {
        inView = true;
        updatePlayback();
      }
    });

    root.querySelectorAll('.adv-sticky:not([data-scroll-ready])').forEach(sticky => {
      sticky.dataset.scrollReady = 'true';
      const updateSticky = () => {
        const desktop = window.matchMedia('(min-width: 861px)').matches;
        sticky.classList.toggle('is-visible', desktop || window.scrollY > window.innerHeight * 0.65);
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    });

    root.querySelectorAll('[data-cure-selector]:not([data-ready])').forEach(selector => {
      const options = [...selector.querySelectorAll('[name="cure-variant"]')];
      const commande = selector.querySelector('form[action*="/cart/add"]');
      const submit = selector.querySelector('[data-cure-submit]');
      const cureId = selector.querySelector('[data-cure-id]');
      const cureTitle = selector.querySelector('[data-cure-title]');
      const curePrice = selector.querySelector('[data-cure-price]');
      // Le bouton HTML reste désactivé et le lien produit visible si l'initialisation échoue.
      if (!options.length || !commande || !submit || !cureId || !cureTitle || !curePrice) return;
      const durationChoices = selector.querySelector('.adv-duration-options');
      const fallback = selector.querySelector('[data-cure-fallback]');
      const selectedOption = () => options.find(option => option.checked && !option.disabled);
      const selectionStorageKey = 'veranelle:funnel-cure';
      const pendingStorageKey = 'veranelle:funnel-cart-pending';
      const checkoutAvailable = typeof window.fetch === 'function' && typeof window.AbortController === 'function';
      const cartRoot = window.Shopify?.routes?.root || '/';
      const requestTimeout = 15000;
      let checkoutStartedAt = null;
      let cartNeedsVerification = false;
      let envoi = false;
      let requestVersion = 0;
      let requestController = null;
      let requestTimer = null;
      const saveSelection = (startCheckout = false) => {
        const selected = selectedOption();
        if (!selected) return;
        if (startCheckout) checkoutStartedAt = Date.now();
        try {
          window.sessionStorage.setItem(selectionStorageKey, JSON.stringify({
            variantId: selected.value,
            months: Number(selected.dataset.months),
            price: selected.dataset.price,
            updatedAt: Date.now(),
            ...(checkoutStartedAt ? { checkoutStartedAt } : {})
          }));
        } catch { /* Le parcours reste utilisable quand le stockage est bloqué. */ }
      };
      const markCartPending = id => {
        cartNeedsVerification = true;
        try {
          window.sessionStorage.setItem(pendingStorageKey, JSON.stringify({ variantId: id, updatedAt: Date.now() }));
        } catch { /* La vérification reste requise en mémoire. */ }
      };
      const confirmCart = () => {
        cartNeedsVerification = false;
        try { window.sessionStorage.removeItem(pendingStorageKey); } catch { /* Stockage bloqué. */ }
      };
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(selectionStorageKey));
        if (Number.isFinite(saved?.checkoutStartedAt)) checkoutStartedAt = saved.checkoutStartedAt;
        // Respecter un choix effectué ou restauré par le navigateur avant l'arrivée du script.
        const initial = selectedOption();
        const changedBeforeInit = initial && !initial.defaultChecked;
        const restored = options.find(option => !option.disabled && option.value === saved?.variantId);
        if (restored && !changedBeforeInit) options.forEach(option => { option.checked = option === restored; });
      } catch { /* Aucune sélection valide à restaurer. */ }
      try {
        const pending = JSON.parse(window.sessionStorage.getItem(pendingStorageKey));
        cartNeedsVerification = typeof pending?.variantId === 'string' && Number.isFinite(pending.updatedAt);
      } catch { /* Aucune opération connue à vérifier. */ }
      const update = () => {
        const selected = selectedOption();
        submit.disabled = !checkoutAvailable || envoi || !selected;
        if (durationChoices) durationChoices.disabled = envoi;
        if (fallback) fallback.hidden = checkoutAvailable && Boolean(selected);
        if (!selected) return;
        submit.textContent = envoi ? 'Ouverture du paiement…' : `Passer à la commande — ${selected.dataset.price}`;
        cureId.value = selected.value;
        cureTitle.textContent = selected.dataset.title;
        curePrice.textContent = selected.dataset.price;
        const reference = selector.querySelector('[data-cure-reference]');
        if (reference) {
          reference.textContent = selected.dataset.reference || '';
          reference.hidden = !selected.dataset.reference;
        }
        const advertorial = selector.closest('.adv') || document;
        advertorial.querySelectorAll('.adv-sticky').forEach(sticky => {
          const label = sticky.querySelector('.adv-sticky__label');
          const price = sticky.querySelector('.adv-sticky__price');
          if (label) label.textContent = `Ma cure de ${selected.dataset.months} mois`;
          if (!price) return;
          const total = price.querySelector('strong');
          let previous = price.querySelector('s');
          if (total) total.textContent = selected.dataset.price;
          if (selected.dataset.reference && !previous) {
            previous = document.createElement('s');
            price.prepend(previous);
          }
          if (previous) {
            previous.textContent = selected.dataset.reference || '';
            previous.hidden = !selected.dataset.reference;
          }
        });
        const withGift = Number(selected.dataset.months) >= 3;
        const recapGift = selector.querySelector('[data-cure-gift]');
        if (recapGift) recapGift.hidden = !withGift;
      };
      options.forEach(option => option.addEventListener('change', () => {
        update();
        saveSelection();
      }));

      if (checkoutAvailable) {
        let errorMessage = selector.querySelector('[data-cure-error]');
        if (!errorMessage) {
          errorMessage = document.createElement('p');
          errorMessage.dataset.cureError = '';
          errorMessage.setAttribute('role', 'alert');
          errorMessage.hidden = true;
          commande.after(errorMessage);
        }
        const cartLink = document.createElement('a');
        cartLink.href = `${cartRoot}cart`;
        cartLink.textContent = 'Vérifier mon panier';
        cartLink.hidden = true;
        errorMessage.after(cartLink);
        const showError = text => {
          errorMessage.textContent = text;
          errorMessage.hidden = false;
          cartLink.hidden = !cartNeedsVerification;
        };
        const resetPending = () => {
          requestVersion += 1;
          if (requestTimer !== null) window.clearTimeout(requestTimer);
          requestTimer = null;
          requestController?.abort();
          requestController = null;
          envoi = false;
          commande.removeAttribute('aria-busy');
        };
        commande.addEventListener('submit', async event => {
          event.preventDefault();
          if (envoi) return;
          // Le navigateur peut restaurer un radio sans déclencher change.
          update();
          const selected = selectedOption();
          if (!selected) {
            showError('Choisissez une cure disponible pour continuer.');
            return;
          }
          const id = selected.value;
          saveSelection(true);
          envoi = true;
          const version = ++requestVersion;
          requestController = new window.AbortController();
          const signal = requestController.signal;
          const json = { 'Content-Type': 'application/json' };
          errorMessage.hidden = true;
          cartLink.hidden = true;
          commande.setAttribute('aria-busy', 'true');
          update();
          // Le délai couvre clear + add, ou GET + lecture JSON, même si fetch ignore abort.
          requestTimer = window.setTimeout(() => {
            if (version !== requestVersion) return;
            resetPending();
            update();
            showError('La connexion prend trop de temps. Votre choix est conservé. Réessayez pour vérifier le panier.');
          }, requestTimeout);
          try {
            if (cartNeedsVerification) {
              // Un POST interrompu peut avoir réussi côté Shopify : ne jamais ajouter à nouveau à l'aveugle.
              const response = await window.fetch(`${cartRoot}cart.js`, { signal, cache: 'no-store' });
              if (version !== requestVersion) return;
              if (!response.ok) throw new Error('panier indisponible');
              const cart = await response.json();
              if (version !== requestVersion) return;
              const item = Array.isArray(cart.items) && cart.items.length === 1 ? cart.items[0] : null;
              const matches = cart.item_count === 1 && item?.quantity === 1
                && String(item.variant_id ?? item.id) === id && !item.selling_plan_allocation;
              if (!matches) {
                resetPending();
                update();
                showError('Le panier n’a pas pu être confirmé. Votre choix est conservé. Vérifiez le panier avant de poursuivre.');
                return;
              }
            } else {
              // La cure choisie remplace le panier. Marquer AVANT le POST pour couvrir un rechargement.
              markCartPending(id);
              const cleared = await window.fetch(`${cartRoot}cart/clear.js`, { method: 'POST', headers: json, signal });
              if (version !== requestVersion) return;
              if (!cleared.ok) {
                // Une erreur serveur peut survenir après la mutation ; seul un refus explicite est réessayable.
                if (cleared.status === 422) confirmCart();
                throw new Error('panier non préparé');
              }
              const added = await window.fetch(`${cartRoot}cart/add.js`, {
                method: 'POST', headers: json, signal,
                body: JSON.stringify({ id, quantity: 1 })
              });
              if (version !== requestVersion) return;
              if (!added.ok) {
                if (added.status === 422) confirmCart();
                throw new Error('ajout refusé');
              }
            }
            if (requestTimer !== null) window.clearTimeout(requestTimer);
            requestTimer = null;
            confirmCart();
            window.location.href = `${cartRoot}checkout`;
          } catch {
            if (version !== requestVersion) return;
            resetPending();
            update();
            showError(cartNeedsVerification
              ? 'La connexion a été interrompue. Votre choix est conservé. Réessayez pour vérifier le panier.'
              : 'Le paiement n’a pas pu s’ouvrir. Votre choix est conservé. Réessayez dans un instant.');
          }
        });
        window.addEventListener('pagehide', resetPending);
        window.addEventListener('pageshow', event => {
          if (event.persisted) resetPending();
          update();
          // Certains navigateurs restaurent les champs après pageshow.
          window.setTimeout(update, 0);
        });
      } else {
        commande.addEventListener('submit', event => event.preventDefault());
        window.addEventListener('pageshow', () => {
          update();
          window.setTimeout(update, 0);
        });
      }
      update();
      selector.dataset.ready = 'true';
    });

    root.querySelectorAll('[data-stagger-reviews]:not([data-reviews-ready])').forEach(carousel => {
      carousel.dataset.reviewsReady = 'true';
      const stage = carousel.querySelector('.adv-pvr-stage');
      const cards = [...carousel.querySelectorAll('[data-review-card]')];
      const currentLabel = carousel.querySelector('[data-review-current]');
      const totalLabel = carousel.querySelector('[data-review-total]');
      if (!stage || cards.length === 0) return;

      let current = 0;
      let pointerStart = null;
      let pointerMoved = false;
      if (totalLabel) totalLabel.textContent = String(cards.length);

      const positionFor = index => {
        let position = (index - current + cards.length) % cards.length;
        if (position > cards.length / 2) position -= cards.length;
        return position;
      };

      const render = () => {
        const compact = stage.clientWidth < 600;
        const gap = Math.min(stage.clientWidth * (compact ? .58 : .28), 310);
        cards.forEach((card, index) => {
          const position = positionFor(index);
          const distance = Math.abs(position);
          const active = position === 0;
          const visible = distance <= 2;
          const x = position * gap;
          const y = active ? -24 : (distance % 2 ? 13 : -10);
          const rotation = active ? 0 : (position < 0 ? -2.6 : 2.6);
          const scale = active ? 1 : Math.max(.86, 1 - distance * .055);
          card.dataset.position = String(position);
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', String(!active));
          card.tabIndex = active ? 0 : -1;
          card.style.zIndex = String(30 - distance);
          card.style.opacity = visible ? String(active ? 1 : Math.max(.3, .72 - distance * .18)) : '0';
          card.style.pointerEvents = visible ? 'auto' : 'none';
          card.style.transform = `translate(-50%,-50%) translate3d(${x}px,${y}px,0) rotate(${rotation}deg) scale(${scale})`;
        });
        if (currentLabel) currentLabel.textContent = String(current + 1);
      };

      const move = steps => {
        current = (current + steps + cards.length) % cards.length;
        render();
      };

      carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-review-next]')?.addEventListener('click', () => move(1));
      cards.forEach(card => card.addEventListener('click', () => {
        if (pointerMoved) return;
        const position = Number(card.dataset.position);
        if (position) move(position);
      }));
      stage.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });
      stage.addEventListener('pointerdown', event => {
        pointerStart = event.clientX;
        pointerMoved = false;
      });
      stage.addEventListener('pointermove', event => {
        if (pointerStart !== null && Math.abs(event.clientX - pointerStart) > 8) pointerMoved = true;
      });
      stage.addEventListener('pointerup', event => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) > 45) move(distance < 0 ? 1 : -1);
        window.setTimeout(() => { pointerMoved = false; }, 0);
      });
      stage.addEventListener('pointercancel', () => { pointerStart = null; pointerMoved = false; });
      new ResizeObserver(render).observe(stage);
      requestAnimationFrame(render);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
